/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import { Action as r } from "../models/NavigationAction.mjs";
const n = {
  33: r.PrevView,
  34: r.NextView,
  35: r.LastInView,
  36: r.FirstInView,
  37: r.Left,
  38: r.Up,
  39: r.Right,
  40: r.Down,
  "meta+38": r.UpperView,
  "meta+40": r.LowerView
};
class p {
  constructor(t) {
    this.bus = t;
  }
  action(t) {
    const o = `${t.ctrlKey || t.metaKey ? "meta+" : ""}${t.keyCode}`;
    return n[o];
  }
  move(t, o, e, i, s) {
    return i ? o === r.UpperView && this.bus.canMoveUp(e) ? (this.bus.moveUp(e, s), t) : o === r.LowerView && this.bus.canMoveDown(e) ? (this.bus.moveDown(e, s), t) : i.move(t, o) : t;
  }
}
export {
  p as NavigationService
};
